module.exports = __webpack_public_path__ + "52ce29d9c1bc50c59fbf502f9080aa72.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/team/CarolinaMastretta.png
// module id = 553
// module chunks = 0